export const STAGE = __STAGE__;
export const isProd = () => /prod/.test(STAGE);
export const isTest = () => /test/i.test(STAGE);
